import { Component, OnInit } from '@angular/core';
import {PricesService} from '../../services/prices/prices.service';

@Component({
  selector: 'app-list-prices',
  templateUrl: './list-prices.component.html',
  styleUrls: ['./list-prices.component.scss']
})
export class ListPricesComponent implements OnInit {

    prices: any;

  constructor(
      private pricesService: PricesService
  ) { }

    ngOnInit(): void {
        const t = this;
        t.loadItems();
    }

    loadItems() {
        const t = this;
        this.pricesService.get().subscribe((data: any) => {
            t.prices = data;
        });
    }

}
